import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, BrewersUnitOfWork } from 'app/core/core.module';
import { Vendor } from 'app/core/model/vendor';
import { confirm } from 'devextreme/ui/dialog';

@Component({
    standalone: false,
    selector: 'app-vendor-overview',
    templateUrl: './vendor-overview.component.html',
    styleUrl: './vendor-overview.component.scss',
})
export class VendorOverviewComponent implements OnInit {
    uow = inject(BrewersUnitOfWork);
    router = inject(Router);
    appInfo = inject(AppInformationService);
    auth = inject(AuthService);

    vendors: Vendor[];

    async ngOnInit() {
        this.appInfo.pleaseWaitShow();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async getData() {
        this.vendors = await this.uow.vendors.whereActive('companyName');
    }

    rowDoubleClick(e: any) {
        this.open(e.data);
    }

    open(vendor?: Vendor) {
        this.router.navigate([`/vendors/${vendor ? vendor.id : 'new'}`]);
    }

    async delete(vendor: Vendor) {
        const success = await confirm('Are you sure you want to delete the selected vendor?', this.appInfo.settings.company);
        if (!success) return;

        this.appInfo.pleaseWaitShow();
        vendor.deleted = new Date();
        vendor.deletedBy = this.auth.currentUser.userName;
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }
}
